const apiConfig = {
  MASTER: `${window._env_.API_MASTER_SERVICE_URL}/t/${window._env_.TENANT}`,
  QMT_APP_URL: `${window._env_.QMT_APP_URL}`,
};

export default apiConfig;
